export default {
  'builderChat.newChat': 'Nueva conversación',
  'builderChat.history': 'Historial de conversaciones',
  'builderChat.closeTab': 'Cerrar pestaña',
  'builderChat.noTabs': 'Sin conversaciones abiertas',
  'builderChat.untitledThread': 'Conversación #{number}',
  'builderChat.untitledFallback': 'Sin título',
  'builderChat.error': 'No se pudo inicializar el chat',
  'builderChat.noConnection': 'No hay conexión. Intenta de nuevo.',
  'builderChat.errorCreatingNewChat': 'No se pudo crear una nueva conversación',
  'builderChat.history.searchPlaceholder': 'Buscar conversación...',
  'builderChat.history.empty': 'No hay conversaciones en el historial',
  'builderChat.history.open': 'Ya está abierta',
  'builderChat.time.justNow': 'Hace un momento',
  'builderChat.time.minutesAgo': 'Hace {n} min',
  'builderChat.time.hoursAgo': 'Hace {n} h',
  'builderChat.time.daysAgo': 'Hace {n} d',
  'builderChat.context.remove': 'Quitar contexto',
  'aiConsumption.title': 'Consumo de IA',
  'aiConsumption.credits': 'Créditos',
  'aiConsumption.cost': 'Costo',
  'aiConsumption.tokens': 'Tokens',
  'aiConsumption.requests': 'Solicitudes',
  'aiConsumption.none': 'Sin consumo registrado',
  'aiConsumption.scope.thread': 'Esta conversación',
  'aiConsumption.scope.total': 'Total',
  'aiConsumption.input': 'Entrada',
  'aiConsumption.output': 'Salida',
  'aiConsumption.cache': 'Caché',
  'aiConsumption.tokensUnit': 'tokens',
};
